import React, {useEffect, useState} from 'react';
import './App.css';
import {BrowserRouter as Router} from "react-router-dom";
import {
    LANGUAGE_ITEM_NAME,
    PATIENT_DATA_STORAGE_ITEM_NAME,
    SESSION_ID_STORAGE_ITEM_NAME,
    SESSION_TIMEOUT_SECONDS
} from "./consts/consts";
import {useSessionTimeout} from "./utils/useSessionTimeout";
import Footer from "./components/Footer";
import {v4 as uuidv4} from 'uuid';
import ScrollToTop from "./utils/ScrollToTop";
import AppRoutes from "./components/AppRoutes";
import {isRTL, Languages, useLanguage} from "./LanguageContext";
import {checkLockStatus} from "./api/AuthorizationApi";
import {getTranslation} from "./consts/translations";


const App = () => {
    const [showVerification, setShowVerification] = useState(false);
    const [loadingStorage, setLoadingStorage] = useState(true);
    const [inputId, setInputId] = useState('')
    const [inputPhone, setInputPhone] = useState('');
    const [acmgReportStatus, setAcmgReportStatus] = useState({status: -1, description: ''});
    const [sessionId, setSessionId] = useState('')
    const [showModal, setShowModal] = useState(false);
    const {language, changeLanguage} = useLanguage();
    const translation = getTranslation(language);

    useEffect(() => {
        switch (language) {
            case Languages.ENGLISH:
                document.documentElement.lang = 'en';
                break;
            case Languages.ARABIC:
                document.documentElement.lang = 'ar';
                break;
            case Languages.RUSSIAN:
                document.documentElement.lang = 'ru';
                break;
            case Languages.HEBREW:
            default:
                document.documentElement.lang = 'he';
                break;
        }
    }, [language]);

    useEffect(() => {
        const storedAcmgReportStatus = sessionStorage.getItem(PATIENT_DATA_STORAGE_ITEM_NAME);
        if (storedAcmgReportStatus) {
            setAcmgReportStatus(JSON.parse(storedAcmgReportStatus));
        }
        setLoadingStorage(false);

        const storedSessionId = sessionStorage.getItem(SESSION_ID_STORAGE_ITEM_NAME);
        if (storedSessionId) {
            setSessionId(storedSessionId);
        } else {
            setSessionId(uuidv4());
        }

        const language = sessionStorage.getItem(LANGUAGE_ITEM_NAME);
        if (language) {
            changeLanguage(language as Languages);
        }
    }, [changeLanguage]);

    useEffect(() => {
        const checkStatus = async () => {
            const locked = await checkLockStatus(translation);
            if (locked) {
                setShowModal(true);
            }
        };

        checkStatus();
    }, [translation]);


    const logout = () => {
        console.log('logout');
        setShowModal(false);
        setInputId('');
        setInputPhone('');
        setShowVerification(false);
        setAcmgReportStatus({status: -1, description: ''});
        setSessionId('');
        sessionStorage.removeItem(PATIENT_DATA_STORAGE_ITEM_NAME);
        sessionStorage.removeItem(SESSION_ID_STORAGE_ITEM_NAME);
    }

    useSessionTimeout(SESSION_TIMEOUT_SECONDS, logout);
    const appDirection: React.CSSProperties = {
        direction: isRTL(language) ? 'rtl' : 'ltr',
    };

    return (
        <div className="app-container" style={appDirection}>
            {loadingStorage ? (
                <div>Loading...</div>
            ) : (
                <Router>
                    <ScrollToTop/>
                    <AppRoutes
                        showVerification={showVerification}
                        setShowVerification={setShowVerification}
                        setAcmgReportStatus={setAcmgReportStatus}
                        inputId={inputId}
                        inputPhone={inputPhone}
                        setInputId={setInputId}
                        setInputPhone={setInputPhone}
                        acmgReportStatus={acmgReportStatus}
                        sessionId={sessionId}
                        setSessionId={setSessionId}
                        logout={logout}
                        showModal={showModal}
                        setShowModal={setShowModal}
                    />
                    <Footer showExitButton={(showVerification || acmgReportStatus.status !== -1) && !showModal}
                            onExit={logout}/>
                </Router>
            )}
        </div>
    );
}


export default App;
